import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { I18n } from "react-redux-i18n";
import PropTypes from "prop-types";
import { getCurrentBrandFromState } from "assets/js/scenes/brand/utils";
import fetchRoute from "utils/routes";
import BrandChannelConfiguration from "./ChannelConfigurations/BrandChannelConfiguration";
import { USER_CHANNELS } from "../const";
import { DEFAULT_COLORS } from "assets/js/scenes/brand/const";
import LogoBrandElement from "assets/js/scenes/brand/components/brandElements/LogoBrandElement";
import ColorBrandElement from "assets/js/scenes/brand/components/brandElements/ColorBrandElement";
import ConfigurationSection from "../components/ConfigurationSection";

const basePath = USER_CHANNELS.LIST_REDIRECTION;
const ListRedirection = (props) => {
	const styleBasePath = basePath + ".styles";
	const base = props.localBrand ? props.localBrand[basePath] : null;
	const defaultBase = props.brand ? props.brand[basePath] : null;
	const styleBased = base?.styles;
	const styleDefaultBase = defaultBase?.styles;
	const channelStringsKey = "list-redirection";
	return (
		<BrandChannelConfiguration
			{...props}
			channelStringsKey={channelStringsKey}
			basePath={basePath}
			preview={() =>
				props.preview(
					`${fetchRoute("listSubscription")}?a=${
						props.accountId
					}&listName=${I18n.t(
						"app-brand-list-redirection-preview-list-name"
					)}%20&type=optin`,
					"ListRedirection"
				)
			}
		>
			<>
				<ConfigurationSection text={I18n._translate("app-brand-section-logo")}>
					<LogoBrandElement
						channelStringsKey={channelStringsKey}
						name="logo"
						imgObj={base?.["logo"]}
						defaultImgObj={defaultBase?.["logo"]}
						path={basePath + ".logo"}
						goToSDK={props.goToSDK}
						usePrimary
					/>
				</ConfigurationSection>
				<ConfigurationSection text={I18n._translate("app-brand-section-text")}>
					<ColorBrandElement
						name="title"
						channelStringsKey={channelStringsKey}
						path={styleBasePath + ".title-color"}
						color={styleBased?.["title-color"]}
						defaultColor={styleDefaultBase?.["title-color"]}
						placeholderColor={DEFAULT_COLORS.BLACK}
						goToSDK={props.goToSDK}
					/>
					<ColorBrandElement
						name="text"
						channelStringsKey={channelStringsKey}
						path={styleBasePath + ".text-color"}
						color={styleBased?.["text-color"]}
						defaultColor={styleDefaultBase?.["text-color"]}
						placeholderColor={DEFAULT_COLORS.BLACK}
						goToSDK={props.goToSDK}
					/>
				</ConfigurationSection>
				<ConfigurationSection
					text={I18n._translate("app-brand-section-button")}
				>
					<ColorBrandElement
						name="button-text"
						channelStringsKey={channelStringsKey}
						path={styleBasePath + ".button-text-color"}
						color={styleBased?.["button-text-color"]}
						defaultColor={styleDefaultBase?.["button-text-color"]}
						placeholderColor={DEFAULT_COLORS.BLACK}
						goToSDK={props.goToSDK}
					/>
					<ColorBrandElement
						name="button-background"
						channelStringsKey={channelStringsKey}
						path={styleBasePath + ".button-background-color"}
						color={styleBased?.["button-background-color"]}
						defaultColor={styleDefaultBase?.["button-background-color"]}
						placeholderColor={DEFAULT_COLORS.BLACK}
						goToSDK={props.goToSDK}
						usePrimary
					/>
				</ConfigurationSection>
				<ConfigurationSection text={I18n._translate("app-brand-section-bg")}>
					<ColorBrandElement
						name="primary-bg"
						channelStringsKey={channelStringsKey}
						path={styleBasePath + ".background-color"}
						color={styleBased?.["background-color"]}
						defaultColor={styleDefaultBase?.["background-color"]}
						goToSDK={props.goToSDK}
						placeholderColor={DEFAULT_COLORS.WHITE}
					/>
				</ConfigurationSection>
			</>
		</BrandChannelConfiguration>
	);
};

ListRedirection.propTypes = {
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	userBrandSDK: PropTypes.object,
	resetTabData: PropTypes.func,
	resellerName: PropTypes.string,
	preview: PropTypes.func,
	accountId: PropTypes.string,
	goToSDK: PropTypes.func,
};

ListRedirection.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				localBrand: state.localBrand.data,
				brand: getCurrentBrandFromState(state),
				resellerName: state.brand?.name,
				accountId: state.global.account.id,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(ListRedirection)
);
